export const DOWNLOAD_START = 'DOWNLOAD_START'
export const DOWNLOAD_ERROR = 'DOWNLOAD_ERROR'
export const DOWNLOAD_UPDATE = 'DOWNLOAD_UPDATE'
export const DOWNLOAD_RETRY = 'DOWNLOAD_RETRY'
export const DOWNLOAD_EMPTY = 'DOWNLOAD_EMPTY'
export const DOWNLOAD_CANCEL = 'DOWNLOAD_CANCEL'
export const SET_DOWNLOAD_FOLDER = 'SET_DOWNLOAD_FOLDER'
export const HANDLE_SHOW_PROGRESS_INDICATOR = 'HANDLE_SHOW_PROGRESS_INDICATOR'
export const EMPTY_DATA_ACTIVE_DOWNLOAD = 'EMPTY_DATA_ACTIVE_DOWNLOAD'
export const HANDLE_CANCEL_DOWNLOAD_LIST = 'HANDLE_CANCEL_DOWNLOAD_LIST'
export const HANDLE_ITEM_CANCEL_FROM_DOWNLOAD = 'HANDLE_ITEM_CANCEL_FROM_DOWNLOAD'
export const ERROR_SAVING_DATA_DOWNLOAD = 'ERROR_SAVING_DATA_DOWNLOAD'
export const SUCCESS_SAVING_DATA_DOWNLOAD = 'SUCCESS_SAVING_DATA_DOWNLOAD'
export const HANDLE_DEFAULT_LIST_DOWNLOAD_HISTORY = 'HANDLE_DEFAULT_LIST_DOWNLOAD_HISTORY'
export const SET_DOWNLOADS_HISTORY = 'SET_DOWNLOADS_HISTORY'
export const HANDLE_IS_FETCHING_HISTORY = 'HANDLE_IS_FETCHING_HISTORY'
export const HANDLE_IS_DOWNLOADING = 'HANDLE_IS_DOWNLOADING'
export const HANDLE_MINE_OR_ALL = 'HANDLE_MINE_OR_ALL'
export const HANDLE_SHOW_MULTIPLE_DOWNLOAD = 'HANDLE_SHOW_MULTIPLE_DOWNLOAD'
export const HANDLE_REFRESH_DOWNLOAD_HISTORY = 'HANDLE_REFRESH_DOWNLOAD_HISTORY'
export const RESUME_DOWNLOAD_SHOW = 'RESUME_DOWNLOAD_SHOW'
export const RESUME_DOWNLOAD_CANCEL = 'RESUME_DOWNLOAD_CANCEL'
export const DOWNLOAD_DATA_EMPTY = 'DOWNLOAD_DATA_EMPTY'
export const DOWNLOAD_CHUNKS_FILES = 'DOWNLOAD_CHUNKS_FILES'
